import { render, staticRenderFns } from "./avisoFin.vue?vue&type=template&id=2650a104&"
import script from "./avisoFin.vue?vue&type=script&lang=js&"
export * from "./avisoFin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports